<template>
  <div id="app"  class="kyzen-app" :class="{'initiating': state == 'init'}">
    <template v-if="state == 'init'">
      <grid-loader :color="'#ffffff'"></grid-loader>
    </template>

    <template v-else-if="state == 'unauthorized'">
      <div class="auth">
        <div class="inn">
          <div class="left-col">
            <div class="intro">
              <h2>Welcome to Collab Digital</h2>
              <p>Collab Digital is a proprietary workflow management platform. Designed to enable the creation of valuable communication assets through effective and efficient project workflow.</p>
              <a style="color: white; font-weight: bold;" href=" https://www.collabagency.com.au/contact" target="_blank">Learn more</a>
            </div>
          </div>
          <div class="right-col">
            <router-view></router-view>
          </div>
        </div>
        <!-- <div class="copyright pt-5 text-center">
          &copy; Copyright <a href="https://www.collabagency.com.au/" target="_blank">Collab Agency</a>.
          All rights reserved.
        </div> -->
      </div>
    </template>

    <template v-else>
      <app-header></app-header>

      <div class="container">
        <main id="main">
          <router-view></router-view>
        </main>
      </div>

      <footer id="footer">
        <div class="inn">
          <div class="copyright">
            &copy; Copyright 2020 | <a href="" target="_blank">The Collaborative Agency Pty Ltd</a>
          </div>
          <ul class="nav-legal">
            <li><a href="">Privacy Policy</a></li>
            <li><a href="">Terms of Service</a></li>
          </ul>
        </div>
      </footer>
      <modals-container></modals-container>
      <vue-progress-bar></vue-progress-bar>
      <notifications position="top center" classes="mynoty"></notifications>
    </template>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { indexOf } from 'lodash'
import GridLoader from 'vue-spinner/src/GridLoader'
import AppHeader from '@/components/global/AppHeader'

export default {
  name: 'app',
  components: {
    GridLoader,
    AppHeader
  },
  data () {
    return {
      state: 'init',
      authRoutes: ['login', 'forgot'],
      env: process.env,
    }
  },
  watch: {
    $route (newVal) {
      let self = this;
      if ( indexOf(self.authRoutes, newVal.name) >= 0 ) {
        self.state = 'unauthorized';
      }
      else {
        self.state = 'initiated';
      }
    }
  },
  computed: mapState({
    isInitiating () {
      return this.state == 'init';
    }
  }),
  mounted () {
    this.init();
  },
  methods: {
    init () {
      let self = this;
      if ( indexOf(self.authRoutes, self.$route.name) >= 0 ) {
        self.state = 'unauthorized';
      }
      else {
        self.state = 'init';
        self.$store.dispatch('INIT_APP')
          .then(() => {
            self.state = 'initiated';
            self.loadRelatedComments();
          });
      }
    },
    loadRelatedComments (){
      let self = this;
      setTimeout(function(){
        self.$store.dispatch('GET_NOTIFICATIONS');
        self.loadRelatedComments();
      }, 10000);
    }
  }
}
</script>

<style lang="scss">
  @import '@/assets/scss/main.scss'
</style>
